/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 12:05:35
 * @FilePath: \hlweb2.0\src\pages\Solution\Asset\ServiceValue\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tabs } from "antd";
import "./index.scss";
function WarrantyManagement() {
  const [activeValue, setActiveValue] = useState(0);
  const [leaving, setLeaving] = useState(null); // 正在退出的索引
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const warrantyInfo = t("solution_asset.asset6", {
    returnObjects: true,
  });
  const handleTabClick = (index) => {
    if (index === activeValue) return;
    setLeaving(activeValue); // 旧的先退出
    setActiveValue(index); // 新的准备进入
  };

  return (
    <div className="warrantyManagement_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{warrantyInfo.title}</div>
          <span></span>
        </div>
      </div>
      <div className="warrantyManagement_con">
        <div className="warrantyManagement_tab">
          {warrantyInfo.titList.map((item, index) => {
            return (
              <div
                className={index === activeValue ? "tabs tabs_active" : "tabs"}
                key={index}
                onClick={() => handleTabClick(index)}
              >
                {item}
              </div>
            );
          })}
        </div>
        <div className={`warrantyManagement_content ${language==='zh'?'warrantyManagement_content_zh':'warrantyManagement_content_en'}`}>
          <div
            className={
              activeValue === 0
                ? "warranty_con warranty_in"
                : leaving === 0
                ? "warranty_con warranty_out"
                : "warranty_con"
            }
          >
            <div className={`con_back con_back1 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back2 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back3 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_tent con_tent1 ${language==='zh'?'con_tent_zh':'con_tent_en'}`}>
              <div className="con_tent_left">
                <div className="con_tent_title">
                  {warrantyInfo.content1.title2}
                </div>
                <div className="con_tent_list">
                  {warrantyInfo.content1.list.map((item, index) => {
                    return (
                      <div className="con_tent_li" key={index}>
                        <div className="con_tent_li_til">
                          <div className="con_tent_li_icon">
                            <img
                              src={
                                require("../../../../assets/images/solution/infoServices/icon.png")
                                  .default
                              }
                            />
                          </div>
                          {item.title}
                        </div>
                        <div className="con_tent_li_det">{item.detail}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="con_tent_right">
                <img src={warrantyInfo.content1.imgUrl} alt="" />
              </div>
            </div>
          </div>
          <div
            className={
              activeValue === 1
                ? "warranty_con warranty_in"
                : leaving === 1
                ? "warranty_con warranty_out"
                : "warranty_con"
            }
          >
            <div className={`con_back con_back1 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back2 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back3 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_tent con_tent2 ${language==='zh'?'con_tent_zh':'con_tent_en'}`}>
              <div className="con_tent_left">
                <div className="con_tent_title">
                  {warrantyInfo.content2.title2}
                </div>
                <div className="con_tent_detail">
                  {warrantyInfo.content2.detail}
                </div>
                <div className="con_tent_list">
                  {warrantyInfo.content2.list.map((item, index) => {
                    return (
                      <div className="con_tent_li" key={index}>
                        {item}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="con_tent_right">
                <img src={warrantyInfo.content2.imgUrl2} alt="" />
                <img
                  style={{
                    position: "absolute",
                    top: "30px",
                    left: "-20px",
                    width: "100%",
                  }}
                  src={warrantyInfo.content2.imgUrl}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            className={
              activeValue === 2
                ? "warranty_con warranty_in"
                : leaving === 2
                ? "warranty_con warranty_out"
                : "warranty_con"
            }
          >
            <div className={`con_back con_back1 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back2 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back3 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_tent con_tent3 ${language==='zh'?'con_tent_zh':'con_tent_en'}`}>
              <div className="con_tent_left">
                <div className="con_tent_title">
                  {warrantyInfo.content3.title2}
                </div>
                <div className="con_tent_list">
                  {warrantyInfo.content3.list.map((item, index) => {
                    return (
                      <div className="con_tent_list_li" key={index}>
                        <div className="con_tent_li_til">{item.tit}</div>
                        <ul>
                          {item.detList.map((item, index) => {
                            return <li key={index}>{item}</li>;
                          })}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="con_tent_right">
                <img src={warrantyInfo.content3.imgUrl2} alt="" />
                <img
                  style={{
                    position: "absolute",
                    top: "30px",
                    left: "-20px",
                    width: "100%",
                  }}
                  src={warrantyInfo.content3.imgUrl}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            className={
              activeValue === 3
                ? "warranty_con warranty_in"
                : leaving === 3
                ? "warranty_con warranty_out"
                : "warranty_con"
            }
          >
            <div className={`con_back con_back1 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back2 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_back con_back3 ${language==='zh'?'con_back_zh':'con_back_en'}`}></div>
            <div className={`con_tent con_tent4 ${language==='zh'?'con_tent_zh':'con_tent_en'}`}>
              <div className="con_tent_left">
                <div className="con_tent_title">
                  {warrantyInfo.content4.title2}
                </div>
                <div className="con_tent_list">
                  {warrantyInfo.content4.list.map((item, index) => {
                    return (
                      <div className="con_tent_li" key={index}>
                        <div className="con_tent_li_til">
                          <div className="con_tent_li_icon">
                            <img
                              src={
                                require("../../../../assets/images/solution/infoServices/icon.png")
                                  .default
                              }
                            />
                          </div>
                          {item.title}
                        </div>
                        <div className="con_tent_li_det">{item.detail}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="con_tent_right">
                <img src={warrantyInfo.content4.imgUrl} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WarrantyManagement;
